module.exports = __webpack_public_path__ + "img/icn-deposit-cd.c9a26847.png";